module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_Bankoslowka_PRZELEW_NA_TEL.c219e382.mp3";